import { atom } from "recoil";
import { LairType } from "../utils/Types";

const lairAtom = atom<LairType | null>({
  key: "lairAtom",
  default: null,
});

export default lairAtom;
